import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="text-center shadow-sm">
            <Card.Body>
              <h1 className="display-1">404</h1>
              <h2>Page Not Found</h2>
              <p className="lead">
                We couldn't find the page you were looking for.
              </p>
              <hr />
              <p>
                Check the URL or navigate back to the dashboard.
              </p>
              <Button
                as={Link}
                to="/"
                variant="primary"
                className="mt-3"
              >
                Go to Dashboard
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
